var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhost3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 337,
    viewBox: "0 0 357 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_206_73)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_206_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.924 60.6562C271.717 59.6305 270.823 58.8874 269.777 58.8706C268.731 58.8538 267.814 59.5678 267.574 60.5863L262.639 81.5411L242.189 85.9425C241.177 86.1604 240.448 87.0478 240.432 88.0833C240.415 89.1189 241.115 90.0292 242.12 90.2795L262.418 95.3351L266.678 116.438C266.885 117.463 267.778 118.206 268.824 118.223C269.87 118.24 270.787 117.526 271.027 116.507L275.962 95.5526L296.412 91.1512C297.424 90.9333 298.153 90.0459 298.17 89.0104C298.186 87.9748 297.487 87.0645 296.482 86.8142L276.184 81.7586L271.924 60.6562Z",
    stroke: "#EAF408",
    strokeWidth: 4.45282,
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_206_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4434 253.38L93.8924 261.683L101.72 263.855L93.7433 265.391L91.6323 273.55L90.1833 265.248L82.3562 263.076L90.3325 261.539L92.4434 253.38Z",
    fill: "#EAF408"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_206_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.508 167.637V191.366C223.508 197.856 226.087 204.086 230.677 208.668C235.566 213.558 242.309 216.16 249.217 215.813L267.142 212.635L234.628 235.363C222.546 243.178 208.485 247.579 194.093 247.468C190.055 247.429 185.994 247.066 181.98 246.364L172.272 244.677C164.488 243.312 157.036 240.733 150.159 237.043C143.282 233.36 136.981 228.589 131.532 222.863C118.457 209.142 111.17 190.925 111.17 171.974V164.813C111.17 123.041 136.327 89.1616 167.343 89.1616C189.306 89.1616 208.335 106.148 217.562 130.919",
    stroke: "#FF9B05",
    strokeWidth: 7.12299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.458 154.017L219.794 127.906C224.069 122.134 232.207 120.919 237.972 125.193C243.745 129.468 244.951 137.606 240.685 143.371L218.864 173.646",
    stroke: "#FF9B05",
    strokeWidth: 7.12299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.171 167.731L92.1656 145.397C87.5207 139.924 88.191 131.731 93.6482 127.078C96.1008 124.996 99.0897 123.979 102.071 123.979C105.746 123.979 109.405 125.54 111.976 128.552L116.203 133.513",
    stroke: "#FF9B05",
    strokeWidth: 7.12299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.312 154.152C139.414 154.152 142.74 147.5 142.74 139.294C142.74 131.088 139.414 124.437 135.312 124.437C131.209 124.437 127.883 131.088 127.883 139.294C127.883 147.5 131.209 154.152 135.312 154.152Z",
    stroke: "#FF9B05",
    strokeWidth: 7.12299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.023 154.152C182.126 154.152 185.452 147.5 185.452 139.294C185.452 131.088 182.126 124.437 178.023 124.437C173.92 124.437 170.594 131.088 170.594 139.294C170.594 147.5 173.92 154.152 178.023 154.152Z",
    stroke: "#FF9B05",
    strokeWidth: 7.12299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.664 211.712C162.304 211.712 166.876 201.321 166.876 188.503C166.876 175.685 162.304 165.294 156.664 165.294C151.023 165.294 146.451 175.685 146.451 188.503C146.451 201.321 151.023 211.712 156.664 211.712Z",
    stroke: "#FF9B05",
    strokeWidth: 7.12299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_206_73",
    x: 68.11,
    y: 56.644,
    width: 246.532,
    height: 245.398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.246
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.12299
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_73",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_206_73",
    x: 210.375,
    y: 33.2667,
    width: 117.852,
    height: 119.466,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.45282
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.9151
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_73",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_206_73",
    x: 54.5258,
    y: 230.003,
    width: 75.0241,
    height: 75.8307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.45282
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.9151
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_73",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_206_73",
    x: 0.0382996,
    y: 0.124237,
    width: 356.142,
    height: 336.383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.7379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_73",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost3);
export default __webpack_public_path__ + "static/media/Ghost_3.fa643af832192d5228110f319ada5a7c.svg";
export { ForwardRef as ReactComponent };